import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { TYPOGRAPHY } from "@store/theme/design";
import { contentSpacingStyles, linkStyles } from "@store/theme/mixins";
import { css } from "styled-components";

export const searchResultTitleSpacing = {
    top: "18px",
    bottom: "10px",
};
export const searchResultItemSpacing = "8px";
export const searchResultGetGridLinkProps = (link?: LinkPresentationProps): LinkPresentationProps => ({
    ...link,
    typographyProps: {
        ...link?.typographyProps,
        css: css`
            display: flex;
            align-items: center;
        `,
    },
});

export interface StoreSearchResultProps {
    title?: TypographyPresentationProps;
    link?: LinkPresentationProps;
    linkFocus?: LinkPresentationProps;
    note?: TypographyPresentationProps;
}

const getLinkProps = (color: string, hoverColor?: string | null): LinkPresentationProps => ({
    typographyProps: {
        ellipsis: true,
        css: css`
            display: block;
        `,
    },
    css: css`
        ${linkStyles(color, hoverColor, false)}
        display: block;
        width: 100%;
        overflow: hidden;
        ${contentSpacingStyles(searchResultItemSpacing, null)}
    `,
});

const searchResultProps: StoreSearchResultProps = {
    title: {
        weight: TYPOGRAPHY.weight.bold,
        transform: "uppercase",
        css: css`
            display: block;
            padding-bottom: 5px;
            border-bottom: 1px solid ${getColor("common.border")};
            ${contentSpacingStyles(searchResultTitleSpacing.top, searchResultTitleSpacing.bottom)}
        `,
    },
    link: getLinkProps("text", "primary"),
    linkFocus: getLinkProps("primary", null),
    note: {
        size: TYPOGRAPHY.size.tiny,
        css: css`
            font-style: italic;
        `,
    },
};

export default searchResultProps;
